export default __webpack_public_path__ + "d98dea3789f7b98c040660ff76e299f1.gif";